import * as React from "react";
import Tooltip, { TooltipProps } from "@material-ui/core/Tooltip";
import { withStyles, Theme } from "@material-ui/core";

type Props = TooltipProps;

const StyledTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    padding: theme.spacing(0.5, 2),
    backgroundColor: theme.palette.secondary.main,
    color: "#fff",
    fontSize: 10,
    fontWeight: 400,
    borderRadius: theme.shape.borderRadius 
  },
}))(Tooltip);

export const PrimaryTooltip: React.FunctionComponent<Props> = props => {
  return <StyledTooltip {...props}></StyledTooltip>;
};
